import { c as _c } from "react/compiler-runtime";
import { postHostedIdentifySessionChallenge, postHostedIdentifySessionChallengeVerify } from '@onefootprint/fetch-hosted';
import request from '@onefootprint/request';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getLogger } from '@/idv/utils';
import type { Context } from '../../identify.types';
import Loading from '../loading';
const {
  logInfo
} = getLogger({
  location: 'challenge-sna-with-fallback'
});
export type ChallengeSnaProps = {
  context: Context;
  onDone: () => Promise<void>;
  onError: () => Promise<void>;
};
const ChallengeSna = t0 => {
  const $ = _c(14);
  const {
    context,
    onDone,
    onError
  } = t0;
  let t1;
  if ($[0] !== context) {
    t1 = async () => await runSnaChallenge(context.state.identifyToken);
    $[0] = context;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onDone) {
    t2 = () => onDone();
    $[2] = onDone;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onError) {
    t3 = err => {
      logInfo(`Error running SNA challenge: ${err}`);
      onError();
    };
    $[4] = onError;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const runSnaChallengeMutation = useMutation(t4);
  let t5;
  if ($[10] !== runSnaChallengeMutation) {
    t5 = () => {
      if (runSnaChallengeMutation.isIdle) {
        runSnaChallengeMutation.mutate(undefined);
      }
    };
    $[10] = runSnaChallengeMutation;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Loading />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
const runSnaChallenge = async (identifyToken: string) => {
  const headers = {
    'X-Fp-Authorization': identifyToken
  };
  const {
    data
  } = await postHostedIdentifySessionChallenge({
    headers,
    body: {
      challengeKind: 'sna'
    }
  });
  const snaLink = data.challengeData.snaLink;
  if (!snaLink) {
    throw new Error('No SNA link found');
  }
  const {
    data: snaResponse
  } = await request({
    url: snaLink,
    method: 'POST'
  });
  // Going to keep this log here for now, need to see what this looks like from a phone number that has SNA enabled
  logInfo(`SNA response: ${snaResponse}`);
  // TODO: parse the challengeResponse out of the SNA response text, once we know what it looks like

  await postHostedIdentifySessionChallengeVerify({
    headers,
    body: {
      challengeResponse: ''
    }
  });
};
export default ChallengeSna;